import { createContext } from "react"

/** The mounted editor's own controls, published so a surrounding card can present them in place.
 * The editor still owns its draft, validation, pending state, captured token and save request;
 * nothing here decides whether a change is permitted or what is sent.
 */
export type InlineEditorControls = {
  isEditing: boolean
  isSaving: boolean
  canEdit: boolean
  saveDisabled: boolean
  edit: () => void
  save: () => void
  cancel: () => void
}

/** Optional in-place destination for an editor's Edit/Save/Cancel controls. */
export const InlineCardEditHost = createContext<((controls: InlineEditorControls | null) => void) | null>(null)
